<template>
  <ValidationObserver
      ref="observer"
      class="transition duration-500 ease-in-out transform w-full"
      style="transition: all 1s !important"
      tag="form"
      @submit.prevent="submit()"
  >
    <div class="w-full flex accreditor-form__shell">
      <v-card class="mx-auto w-full" flat max-height="auto" max-width="1000">
        <div class="flex flex-wrap accreditor-form__grid">
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Accreditor's Name</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
                required: true,
                regex: '^[A-Za-z][A-Za-z ]*$',
              }"
            >
              <input
                  id="accreditorName"
                  v-model="formValues.accreditorName"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  placeholder="accreditorName"
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-2 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Accreditor's Ownership</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.accredatorOwnershipId"
                  :clearable="clearable"
                  :elevation="1"
                  :items="ACCREDATOR_OWNERSHIP"
                  :loading="accOwnerLoading"
                  :searchable="searchable"
                  dense
                  item-text="name"
                  item-value="id"
                  label="accreditor's ownership"
                  solo
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>

          <div class="w-full md:w-1/2 px-3 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Region</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.region_id"
                  :clearable="clearable"
                  :elevation="1"
                  :items="REGIONS"
                  :loading="regionLoading"
                  :searchable="searchable"
                  dense
                  item-text="name"
                  item-value="id"
                  label="regions"
                  solo
                  @change="regionOnChange($event)"
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 md:mb-0  ">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Zone</label
            >

            <v-select
                v-model="formValues.zone_id"
                :clearable="clearable"
                :elevation="1"
                :items="FILTERED_ZONES"
                :loading="zoneLoading"
                :searchable="searchable"
                dense
                item-text="name"
                item-value="id"
                label="zones"
                solo
                @change="zoneOnChange($event)"
            ></v-select>

            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 md:mb-0">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Woreda</label
            >

            <v-select
                v-model="formValues.woreda_id"
                :clearable="clearable"
                :elevation="1"
                :items="FILTERED_WOREDAS"
                :loading="woredaLoading"
                :searchable="searchable"
                dense
                item-text="name"
                item-value="id"
                label="woredas"
                solo
            ></v-select>

            <br/>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Accreditor's Director Name</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="accreditorDirectorName"
                  v-model="formValues.accreditorDirectorName"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  placeholder="accreditorDirectorName"
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Accreditor's Director Email Address</label
            >
            <validation-provider v-slot="{ errors }" rules="required|email">
              <input
                  id="accreditorDirectorEmail"
                  v-model="formValues.accreditorDirectorEmail"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  placeholder="accreditorDirectorEmail"
                  type="email"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Accreditor's Director Phone Number</label
            >
            <validation-provider
                v-slot="{ errors }"
                mode="eager"
                :rules="{
                required: true,
                phone_regex: '^\\+251[97]\\d{8}$',
              }"
            >
              <input
                  id="accreditorDirectorPhone"
                  v-model="formValues.accreditorDirectorPhone"
                  inputmode="numeric"
                  maxlength="13"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  placeholder="+2519xxxxxxx"
                  type="tel"
                  @input="onPhoneInput('accreditorDirectorPhone', $event.target.value, true)"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Institutional Email</label
            >
            <validation-provider v-slot="{ errors }" rules="required|email">
              <input
                  id="institutionalEmail"
                  v-model="formValues.institutionalEmail"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  placeholder="institutionalEmail"
                  type="email"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Institutional Phone Number</label
            >
            <validation-provider
                v-slot="{ errors }"
                mode="eager"
                :rules="{
                required: true,
                institution_phone_regex: true,
              }"
            >
              <input
                  id="institutionalPhone"
                  v-model="formValues.institutionalPhone"
                  inputmode="numeric"
                  maxlength="13"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  placeholder="+2511xxxxxxx or +2519xxxxxxx"
                  type="tel"
                  @input="onInstitutionPhoneInput('institutionalPhone', $event.target.value, true)"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Accreditation Date:
            </label>
            <validation-provider v-slot="{ errors }" rules="required">
              <v-menu
                  ref="menu"
                  v-model="startMenu"
                  :close-on-content-click="false"
                  max-width="290px"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="formValues.accreditationDate"
                      label="accreditation date"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    ref="accreditationDate"
                    v-model="formValues.accreditationDate"
                    :max="date"
                    no-title
                    scrollable
                    @input="startMenu = false"
                ></v-date-picker>
              </v-menu>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>

            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Accreditation Code</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="accreditationCode"
                  v-model="formValues.accreditationCode"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  placeholder="accreditationCode"
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/3 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Accredator's Status</label
            >
            <validation-provider v-slot="{ errors }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-switch
                      v-model="formValues.isActive"
                      color="green"
                      hide-details
                      v-on="on"
                  ></v-switch>
                </template>
                <span>{{
                    formValues.isActive == true ? "Active" : "Not Active"
                  }}</span>
              </v-tooltip>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/3 px-3 mb-6 md:mb-0">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Latitude</label
            >
            <!-- <validation-provider rules="required" v-slot="{ errors }"> -->
            <input
                id="latitude"
                v-model="formValues.latitude"
                readonly
                class="
                shadow
                appearance-none
                border
                rounded
                w-full
                py-2
                px-3
                text-gray-700
                leading-tight
                focus:outline-none focus:shadow-outline
              "
                name
                placeholder="eg-7.00000"
                type="number"
            />
            <!-- <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider> -->
            <br/>
          </div>
          <div class="w-full md:w-1/3 px-3 mb-6 md:mb-0">
            <label
                class="
              block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Longtiude</label
            >
            <!-- <validation-provider rules="required" v-slot="{ errors }"> -->
            <input
                id="longtiude"
                v-model="formValues.longtiude"
                readonly
                class="
              shadow
                appearance-none
                border
                rounded
                w-full
                py-2
                px-3
                text-gray-700
                leading-tight
                focus:outline-none focus:shadow-outline
              "
                name
                placeholder="eg-8.00000"
                type="number"
            />
            <!-- <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider> -->
            <br/>
          </div>
          <div class="w-full px-3 mb-6">
            <div class="accreditor-form__map-header">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                "
              >Location on Map</label>
              <v-btn
                  class="accreditor-form__map-toggle"
                  text
                  small
                  type="button"
                  @click="toggleMapSize"
              >
                <v-icon left small>{{ mapExpanded ? "mdi-arrow-collapse" : "mdi-arrow-expand" }}</v-icon>
                {{ mapExpanded ? "Minimize map" : "Expand map" }}
              </v-btn>
            </div>
            <div class="accreditor-form__map-shell" :class="{ 'is-expanded': mapExpanded }">
              <div ref="accreditorMap" class="accreditor-form__map"></div>
            </div>
            <div class="accreditor-form__map-hint">
              Click on the map to set latitude and longitude (Ethiopia only).
            </div>
          </div>
        </div>
        <div class="flex flex-wrap accreditor-form__actions">
          <div class="w-full">
            <button
                class="accreditor-form__submit"
                type="button"
                @click="showConfirmation(formValues.editMode)"
            >
              {{ formValues.editMode ? "Update Accreditor" : "Add Accreditor" }}
            </button>
          </div>
          <div class="md:w-2/3"></div>
        </div>
      </v-card>
      <confirmationModal
          v-if="confirmation"
          @confirmed="submit"
          :title="title"
          @close="confirmation = false"
          @openDialog="true"
      >
      </confirmationModal>
    </div>
  </ValidationObserver>
</template>

<script>
import "../../plugins/leaflet/leaflet.css";
import * as L from "leaflet";
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {isValidEthiopianPhone, normalizeEthiopianPhone} from "@/utils/phone";
import {email, regex, required} from "vee-validate/dist/rules";
import {getAccredatorOwnership, getRegionList, getWoredaByZoneId, getZoneByRegionId,} from "@/utils/helper";
import ethiopic from "ethiopic-calendar";
import confirmationModal from "../../common/confirmation-modal.vue";

const ETHIOPIA_GEOJSON = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      id: "ETH",
      properties: {
        name: "Ethiopia",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [37.90607, 14.95943],
            [38.51295, 14.50547],
            [39.0994, 14.74064],
            [39.34061, 14.53155],
            [40.02625, 14.51959],
            [40.8966, 14.11864],
            [41.1552, 13.77333],
            [41.59856, 13.45209],
            [42.00975, 12.86582],
            [42.35156, 12.54223],
            [42, 12.1],
            [41.66176, 11.6312],
            [41.73959, 11.35511],
            [41.75557, 11.05091],
            [42.31414, 11.0342],
            [42.55493, 11.10511],
            [42.776852, 10.926879],
            [42.55876, 10.57258],
            [42.92812, 10.02194],
            [43.29699, 9.54048],
            [43.67875, 9.18358],
            [46.94834, 7.99688],
            [47.78942, 8.003],
            [44.9636, 5.00162],
            [43.66087, 4.95755],
            [42.76967, 4.25259],
            [42.12861, 4.23413],
            [41.855083, 3.918912],
            [41.1718, 3.91909],
            [40.76848, 4.25702],
            [39.85494, 3.83879],
            [39.559384, 3.42206],
            [38.89251, 3.50074],
            [38.67114, 3.61607],
            [38.43697, 3.58851],
            [38.120915, 3.598605],
            [36.855093, 4.447864],
            [36.159079, 4.447864],
            [35.817448, 4.776966],
            [35.817448, 5.338232],
            [35.298007, 5.506],
            [34.70702, 6.59422],
            [34.25032, 6.82607],
            [34.0751, 7.22595],
            [33.56829, 7.71334],
            [32.95418, 7.78497],
            [33.2948, 8.35458],
            [33.8255, 8.37916],
            [33.97498, 8.68456],
            [33.96162, 9.58358],
            [34.25745, 10.63009],
            [34.73115, 10.91017],
            [34.83163, 11.31896],
            [35.26049, 12.08286],
            [35.86363, 12.57828],
            [36.27022, 13.56333],
            [36.42951, 14.42211],
            [37.59377, 14.2131],
            [37.90607, 14.95943],
          ],
        ],
      },
    },
  ],
};

const ETHIOPIA_POLYGON = ETHIOPIA_GEOJSON.features[0].geometry.coordinates[0];

const isPointInPolygon = (lat, lng, polygon) => {
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i][0];
    const yi = polygon[i][1];
    const xj = polygon[j][0];
    const yj = polygon[j][1];
    const intersect =
        (yi > lat) !== (yj > lat) &&
        lng < ((xj - xi) * (lat - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
};

extend("required", {
  ...required,
  message: "This field is required",
});

extend("phone_regex", {
  ...regex,
  message: "Use +251 then 9 or 7 and 8 digits (e.g. +2519xxxxxxx).",
});
extend("institution_phone_regex", {
  message: "Use +251 followed by 9 digits (e.g. +2511xxxxxxx or +2519xxxxxxx).",
  validate: (value) =>
      !value ||
      isValidEthiopianPhone(value, {allowedStartingDigits: null}),
});
extend("regex", {
  ...regex,
  message: "Name should contain only letters",
});
extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  props: {
    accreditor: Object,
  },
  components: {
    confirmationModal,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      formValues: {
        accreditorName: "",
        accreditorGeolocation: "",
        accredatorOwnershipId: "",
        accreditorDirectorName: "",
        accreditorDirectorEmail: "",
        accreditorDirectorPhone: "",
        institutionalEmail: "",
        accreditationDate: "",
        institutionalPhone: "",
        accreditationCode: "",
        longtiude: "",
        latitude: "",
        woreda_id: null,
        zone_id: null,
        region_id: null,
        isActive: true,
        editMode: false,
      },
      startMenu: false,
      ACCREDATOR_OWNERSHIP: [],
      date: new Date().toISOString().substr(0, 10),
      etDate: null,
      clearable: true,
      searchable: true,
      accOwnerLoading: false,
      REGIONS: [],
      FILTERED_ZONES: [],
      FILTERED_WOREDAS: [],
      regionLoading: false,
      zoneLoading: false,
      woredaLoading: false,

      confirmation: false,
      title: "",
      map: null,
      mapMarker: null,
      mapExpanded: false,
      ethiopiaBounds: null,
    };
  },
  async beforeMount() {
    this.accOwnerLoading = true;
    const res = await getAccredatorOwnership();
    const filteredData = res.filter(item => item.name !== "Private");
    this.ACCREDATOR_OWNERSHIP = filteredData;
    this.accOwnerLoading = false;
    this.regionLoading = true;
    this.REGIONS = await getRegionList();
    this.regionLoading = false;
  },
  async created() {
    const date = new Date().toISOString().substr(0, 10);
    this.etDate = this.convertGE(date);
    if (this.accreditor != null) {
      this.formValues = this.accreditor;
      this.formValues.editMode = true;

      this.formValues.region_id
          ? this.regionOnChange(this.formValues.region_id)
          : "";
      this.formValues.zone_id ? this.zoneOnChange(this.formValues.zone_id) : "";
    }
    this.formValues.accreditorDirectorPhone = normalizeEthiopianPhone(
        this.formValues.accreditorDirectorPhone,
        {forcePrefix: true}
    );
    this.formValues.institutionalPhone = normalizeEthiopianPhone(
        this.formValues.institutionalPhone,
        {forcePrefix: true, allowedStartingDigits: null}
    );
  },
  mounted() {
    this.$nextTick(() => {
      this.initMap();
    });
  },
  beforeDestroy() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  },
  methods: {
    onPhoneInput(field, value, forcePrefix = false) {
      const normalized = normalizeEthiopianPhone(value, {forcePrefix});
      if (normalized !== this.formValues[field]) {
        this.formValues[field] = normalized;
      }
    },
    onInstitutionPhoneInput(field, value, forcePrefix = false) {
      const normalized = normalizeEthiopianPhone(value, {
        forcePrefix,
        allowedStartingDigits: null,
      });
      if (normalized !== this.formValues[field]) {
        this.formValues[field] = normalized;
      }
    },
    async showConfirmation(editMode) {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();
      if (!this.isEthiopiaSelectionValid()) {
        this.$toast.error("Please select a location within Ethiopia.");
        return;
      }

      this.confirmation = true;
      this.title = editMode? "Update Accreditor" : "Add Accreditor";
    },
    async regionOnChange(event) {
      this.zoneLoading = true;
      this.FILTERED_ZONES = [];
      this.FILTERED_WOREDAS = [];
      const regionId = event;
      event ? (this.FILTERED_ZONES = await getZoneByRegionId(regionId)) : null;
      this.zoneLoading = false;
    },
    async zoneOnChange(event) {
      this.woredaLoading = true;
      const zoneId = event;
      event ? (this.FILTERED_WOREDAS = await getWoredaByZoneId(zoneId)) : null;
      this.woredaLoading = false;
    },
    convertGE(val) {
      if (!val) return val;
      const [year, month, day] = val.split("-").map(Number);
      if (this.pickerType === "year") {
        let etDate = ethiopic.ge(year, month || 6, day || 1); // so it will be the same year in both directions
        return etDate.year.toString().padStart(4, "0");
      } else {
        let etDate = ethiopic.ge(year, month || 1, day || 1);
        return (
            etDate.year.toString().padStart(4, "0") +
            "-" +
            etDate.month.toString().padStart(2, "0") +
            "-" +
            etDate.day.toString().padStart(2, "0")
        );
      }
    },
    initMap() {
      if (!this.$refs.accreditorMap) return;
      if (this.map) {
        this.map.remove();
        this.map = null;
      }
      const ethiopiaLayer = L.geoJSON(ETHIOPIA_GEOJSON, {interactive: false});
      const ethiopiaBounds = ethiopiaLayer.getBounds();
      this.ethiopiaBounds = ethiopiaBounds;
      const map = L.map(this.$refs.accreditorMap, {
        attributionControl: false,
        maxBounds: ethiopiaBounds,
        maxBoundsViscosity: 1.0,
      });

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {}).addTo(map);
      ethiopiaLayer.addTo(map);

      const minZoom = map.getBoundsZoom(ethiopiaBounds);
      map.setMinZoom(minZoom);
      map.fitBounds(ethiopiaBounds, {padding: [12, 12]});
      this.map = map;

      const existingLat = Number(this.formValues.latitude);
      const existingLng = Number(this.formValues.longtiude);
      if (Number.isFinite(existingLat) && Number.isFinite(existingLng)) {
        this.setMapMarker(existingLat, existingLng);
      }

      map.on("click", (event) => {
        const {lat, lng} = event.latlng;
        if (!isPointInPolygon(lat, lng, ETHIOPIA_POLYGON)) {
          return;
        }
        this.formValues.latitude = lat.toFixed(6);
        this.formValues.longtiude = lng.toFixed(6);
        this.setMapMarker(lat, lng);
      });
    },
    toggleMapSize() {
      this.mapExpanded = !this.mapExpanded;
      this.$nextTick(() => {
        if (this.map) {
          this.map.invalidateSize();
        }
      });
    },
    setMapMarker(lat, lng) {
      if (!this.map) return;
      const latLng = L.latLng(lat, lng);
      if (!this.mapMarker) {
        this.mapMarker = L.circleMarker(latLng, {
          radius: 8,
          color: "#1976d2",
          fillColor: "#1976d2",
          fillOpacity: 0.75,
        }).addTo(this.map);
      } else {
        this.mapMarker.setLatLng(latLng);
      }
      this.map.panTo(latLng);
    },
    isEthiopiaSelectionValid() {
      const lat = Number(this.formValues.latitude);
      const lng = Number(this.formValues.longtiude);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        return true;
      }
      return isPointInPolygon(lat, lng, ETHIOPIA_POLYGON);
    },
    async submit() {
      this.$emit("registerOrUpdateAccreditor", this.formValues);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.accreditor-form__shell {
  padding: 12px;
}

.accreditor-form__grid {
  margin: 12px 16px 6px;
  row-gap: 12px;
}

.accreditor-form__grid > div {
  margin-bottom: 0 !important;
}

.accreditor-form__grid br {
  display: none;
}

.accreditor-form__actions {
  margin: 8px 16px 16px;
  justify-content: flex-end;
}

.accreditor-form__actions .w-full {
  display: flex;
  justify-content: flex-end;
}

.accreditor-form__submit {
  background: #1976d2;
  border: 1px solid #1976d2;
  color: #ffffff;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 6px;
}

.accreditor-form__submit:hover {
  background: #1565c0;
  border-color: #1565c0;
}

.accreditor-form__map-shell {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #f8fafc;
}

.accreditor-form__map {
  height: 260px;
  width: 100%;
}

.accreditor-form__map-shell.is-expanded .accreditor-form__map {
  height: 70vh;
}

.accreditor-form__map-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.accreditor-form__map-header label {
  margin-bottom: 0;
}

.accreditor-form__map-toggle {
  color: #1976d2 !important;
  text-transform: none;
  font-weight: 600;
}

.accreditor-form__map-hint {
  margin-top: 8px;
  font-size: 12px;
  color: #475569;
}

.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}
</style>
